export var pl = {
  meta: {
    title: "UgrzejMnie — Paliwo, serwis kotłowni, klimatyzacja i fotowoltaika",
    description: "UgrzejMnie — zamów paliwo (propan, pellet, groszek, gaz), serwis kotłowni i pomp ciepła, klimatyzację lub fotowoltaikę. Lokalni serwisanci odpowiadają, Ty wybierasz najlepszą ofertę.",
    ogTitle: "UgrzejMnie — Paliwo, serwis, klima i PV",
    ogDescription: "Zamów paliwo, serwis ogrzewania, klimatyzację lub fotowoltaikę w kilka minut. Lokalni fachowcy odpowiadają — Ty wybierasz ofertę.",
  },
  nav: {
    skip: "Przejdź do treści",
    homeAria: "UgrzejMnie — strona główna",
    aria: "Nawigacja główna",
    home: "Strona główna",
    how: "Jak to działa",
    app: "Aplikacja",
    offer: "Co zamawiasz",
    service: "Serwis",
    payments: "Płatności",
    trust: "Bezpieczeństwo",
    provider: "Dla dostawców",
    fuelProviders: "Dla Składów & Paliw",
    technicians: "Dla Serwisantów",
    more: "Więcej",
    download: "Pobierz aplikację",
    game: "Gra",
    menu: "Menu",
  },
  lang: {
    label: "Wybierz język",
  },
  trustBar: {
    label: "Elastyczne rozliczenia",
    text: "Płatności online Stripe, odroczone Klarna (za 30 dni) lub przy odbiorze — zależnie od wybranej oferty dostawcy.",
  },
  hero: {
    headline: "Paliwo i serwis kotłowni — gdy trzeba.",
    lead: "Zamów propan, pellet, gaz, groszek, serwis ogrzewania, klimatyzację lub fotowoltaikę w kilka minut. Lokalni serwisanci odpowiadają — Ty wybierasz ofertę.",
    downloadAndroid: "Pobierz na Androida",
    downloadIos: "Pobierz na iPhone (już wkrótce)",
    securityNote: "Zamawiaj bezpiecznie w aplikacji — potwierdzenie zamówienia wymaga Twojego działania.",
    forProviders: "Dla dostawców",
    playGame: "Zagraj w Ugrzej Osiedle",
  },
  how: {
    heading: "Jak to działa",
    sub: "Trzy kroki — od zlecenia do dostawy lub serwisu u Ciebie.",
    step1: {
      title: "Zamów",
      desc: "Opisz potrzebę — paliwo, serwis ogrzewania, klimatyzację lub fotowoltaikę. Podaj lokalizację i termin.",
    },
    step2: {
      title: "Oferty serwisantów",
      desc: "Lokalni dostawcy i serwisanci odpowiadają w aplikacji. Porównuj ceny i terminy.",
    },
    step3: {
      title: "Dostawa / serwis",
      desc: "Wybierz ofertę — paliwo jedzie do Ciebie, serwisant przyjeżdża na umówiony termin.",
    },
    cluster: {
      kicker: "Paliwo z sąsiadami",
      title: "Zrzutka — wspólna dostawa",
      desc: "Zamawiasz pellet, węgiel lub gaz? Otwórz zrzutkę w aplikacji i wyślij link sąsiadom. Łączcie ilości na jedną trasę — często wychodzi taniej niż osobne dojazdy.",
      cta: "Otwórz w aplikacji",
    },
    slots: {
      kicker: "Okazje na trasie",
      title: "Wolne sloty i tańsze dojazdy",
      desc: "Dostawcy paliw i serwisanci publikują swoje planowane przejazdy. Jeśli mieszkasz wzdłuż trasy, możesz dołączyć ze swoim zleceniem i skorzystać ze znacznie niższej ceny lub braku kosztów dojazdu.",
      cta: "Sprawdź okazje",
    },
  },
  app: {
    heading: "Aplikacja w akcji",
    sub: "Klient, dostawca i pulpit — tak wygląda UgrzejMnie od środka.",
    slide1: "Szybkie zamówienie",
    slide2: "Katalog usług",
    slide3: "Oferty i wyceny",
    slide4: "Panel dostawcy",
    slide5: "Twoje specjalizacje",
    slide6: "Wycena zlecenia",
    slide7: "Pulpit zleceń",
    slide8: "Szybka wycena",
    prev: "Poprzedni ekran",
    next: "Następny ekran",
    dots: "Wybór ekranu",
    dot: "Ekran",
  },
  offer: {
    heading: "Co zamawiasz",
    sub: "Jedna aplikacja na paliwo, ogrzewanie, klimatyzację i fotowoltaikę — fachowiec, gdy trzeba.",
    propan: {
      title: "Propan",
      desc: "Uzupełnienie zbiornika — dostawa pod wskazany adres, bez dzwonienia po hurtowni.",
    },
    pellet: {
      title: "Pellet i groszek",
      desc: "Sezonowe zamówienia paliwa stałego — porównaj oferty dostawców w okolicy.",
    },
    heatpump: {
      title: "Pompa ciepła",
      desc: "Przegląd, serwis i naprawa — technicy z doświadczeniem w Twoim systemie grzewczym.",
    },
    solidBoiler: {
      title: "Kocioł na paliwo stałe",
      desc: "Czyszczenie, regulacja spalania, wymiana elementów — serwis na miejscu.",
    },
    gas: {
      title: "Gaz i LPG",
      desc: "Dostawa i uzupełnianie zbiorników gazu, serwis kotłowni gazowych oraz instalacji LPG.",
    },
    electric: {
      title: "Ogrzewanie elektryczne",
      desc: "Przeglądy, naprawy i wymiana elementów instalacji elektrycznego ogrzewania domu.",
    },
    ac: {
      title: "Klimatyzacja",
      desc: "Serwis, czyszczenie i montaż klimatyzacji — lokalni technicy z uprawnieniami F-Gaz.",
    },
    pv: {
      title: "Fotowoltaika",
      desc: "Serwis instalacji PV oraz montaż lub rozbudowa — wyceny od lokalnych instalatorów.",
    },
  },
  reminders: {
    heading: "Nie przegap przeglądu",
    sub: "Zapisz swoją instalację grzewczą, a UgrzejMnie przypomni o terminie serwisu zanim zacznie się sezon.",
    step1: {
      title: "Dodaj kotłownię",
      desc: "Zapisz adres, typ ogrzewania, model kotła lub pompy ciepła oraz parametry instalacji w jednym miejscu.",
    },
    step2: {
      title: "Ustal termin serwisu",
      desc: "Wybierz datę kolejnego przeglądu. System sam policzy, ile czasu pozostało do wizyty serwisanta.",
    },
    step3: {
      title: "Otrzymaj przypomnienie",
      desc: "Przed terminem dostaniesz powiadomienie i łatwo zamówisz serwis u sprawdzonego lokalnego fachowca.",
    },
  },
  payments: {
    heading: "Wygodne i bezpieczne płatności za opał i serwis",
    sub: "Na ugrzejmnie.pl łączymy Cię bezpośrednio z lokalnymi dostawcami paliw grzewczych i serwisantami. To dostawcy określają akceptowane metody płatności dla swoich ofert, dzięki czemu możesz wybrać rozwiązanie najbardziej dopasowane do Twoich potrzeb.",
    klarna: {
      title: "Kup teraz, zapłać później z Klarna",
      desc: "Wybrani dostawcy oferują elastyczne płatności odroczone Klarna. Zamów pellet, groszek, drewno lub gaz, a warunki spłaty (w tym ewentualne raty) zobaczysz w Checkout Klarna przed potwierdzeniem.",
      note: "Dostępne u dostawców oferujących płatności Klarna",
    },
    stripe: {
      title: "Szybkie i bezpieczne płatności Stripe",
      desc: "Płać błyskawicznie kartą (Visa, Mastercard), BLIK-iem lub Przelewy24. Na niektórych urządzeniach Stripe Checkout może też udostępnić portfel cyfrowy. System Stripe gwarantuje wysoki poziom bezpieczeństwa (PCI-DSS) i potwierdzenie transakcji.",
      note: "Dostępne u dostawców obsługujących płatności online",
    },
    cash: {
      title: "Płatność u kierowcy (gotówka)",
      desc: "Wolisz tradycyjnie? Wielu lokalnych dostawców umożliwia rozliczenie gotówką przy dostawie lub realizacji usługi — według ceny bazowej oferty, bez dodatkowej opłaty platformy.",
      note: "Szczegóły płatności znajdziesz na karcie konkretnej oferty",
    },
    promo: {
      title: "Zamów opał na zimę bez natychmiastowego obciążania budżetu",
      desc: "Szukaj na ugrzejmnie.pl dostawców oferujących płatności Klarna — odbierz opał zgodnie z umową, a rozliczenie z Klarną przeprowadź według jej warunków prezentowanych w Checkout.",
      days: "30",
      daysUnit: "dni",
    },
  },
  trust: {
    heading: "Zaufanie i bezpieczeństwo",
    sub: "Twoje dane i płatności są chronione na każdym etapie — od zlecenia po rozliczenie z dostawcą.",
    encryption: {
      title: "Szyfrowane dane osobowe",
      desc: "Wrażliwe dane, takie jak numer PESEL przy dostawach paliw, są szyfrowane i przekazywane wyłącznie wybranemu dostawcy.",
    },
    certified: {
      title: "Certyfikowane płatności",
      desc: "Płatności online realizuje Stripe z najwyższym standardem bezpieczeństwa PCI-DSS Level 1. Twoje dane karty nigdy nie są przechowywane na naszych serwerach.",
    },
    marketplace: {
      title: "Marketplace lokalnych dostawców",
      desc: "UgrzejMnie łączy Cię ze sprawdzonymi serwisantami i dostawcami z Twojej okolicy. Umowa i realizacja pozostają między Tobą a wybranym fachowcem.",
    },
    reviews: {
      title: "Autentyczne, zweryfikowane opinie",
      desc: "Koniec ze sztucznymi ocenami. Recenzję może wystawić wyłącznie klient, którego zlecenie zostało fizycznie zrealizowane i potwierdzone podpisem cyfrowym.",
    },
    notifications: {
      title: "Powiadomienia o statusie zlecenia",
      desc: "Dostajesz powiadomienia o nowych ofertach, zmianach statusu i zbliżającym się serwisie, aby niczego nie przegapić.",
    },
  },
  provider: {
    heading: "Zostań dostawcą UgrzejMnie",
    sub: "Dotrzyj do klientów, którzy potrzebują paliwa, serwisu ogrzewania, klimatyzacji lub fotowoltaiki w Twojej okolicy. Zarządzaj ofertami, płatnościami i zleceniami z telefonu oraz z pulpitu — w jednym ekosystemie.",
    benefitMixedRoute: {
      title: "Trasa Mieszana A+B i Kurs Dnia",
      desc: "Łącz zlecenia z platformy z własnymi klientami ze składu na jednej ciężarówce. Wprowadzaj zlecenia własne za symboliczną opłatą techniczną od 0,3%. System automatycznie układa kolejność dostaw od Twojego placu i pilnuje ładowności auta.",
    },
    benefitDriverManifest: {
      title: "Kierowca bez aplikacji, e-WZ i offline",
      desc: "Zero instalowania i logowania. Kierowca rano skanuje 1 kod QR na telefonie: ma nawigację Google Maps, pobieranie gotówki, podpisywanie odbioru z numerem PESEL/dowodem pod zwolnienie z akcyzy oraz możliwość dodania klienta „z trasy” nawet bez zasięgu LTE.",
    },
    benefitRouteSlots: {
      title: "Sloty tras i zlecenia po drodze",
      desc: "Planujesz kurs z wolną ładownością lub terminem serwisowym? Opublikuj trasę przejazdu — aplikacja przyciągnie zamówienia i zlecenia wzdłuż Twojego korytarza transportowego.",
    },
    benefitReputation: {
      title: "System zweryfikowanych opinii",
      desc: "Ocenę mogą wystawić wyłącznie klienci po faktycznie zrealizowanym zleceniu potwierdzonym podpisem cyfrowym. Budujesz silną markę bez ryzyka fałszywych opinii od konkurencji.",
    },
    benefit1: {
      title: "Elastyczne płatności i transparentne prowizje",
      desc: "Sam decydujesz, czy akceptujesz gotówkę, płatność online (Stripe, BLIK, Przelewy24) czy Klarnę. Prowizje platformy są widoczne przy każdej ofercie, a Ty otrzymujesz środki bezpośrednio od klienta.",
    },
    benefit2: {
      title: "Zlecenia na WhatsApp",
      desc: "Nie musisz stale śledzić aplikacji. Włącz powiadomienia WhatsApp, a nowe zlecenia w Twojej okolicy trafią bezpośrednio na Twój telefon. Złożysz ofertę jednym kliknięciem przez dedykowany, bezpieczny link bez konieczności logowania się do panelu.",
    },
    benefit3: {
      title: "Aplikacja desktopowa",
      desc: "Pracujesz przy biurku? Pobierz wersję na Windows, macOS lub Linux i obsługuj zlecenia z komputera. Pełne zarządzanie kontem pozostaje w aplikacji mobilnej, więc poufne ustawienia są bezpieczne.",
    },
    benefit4: {
      title: "Ustaw zasięg swoich usług",
      desc: "Sam decydujesz, jak daleko dojedziesz. Ustaw promień działania od 10 do 200 km — zmiany synchronizują się automatycznie między aplikacją mobilną a pulpitem.",
    },
    benefit5: {
      title: "Subskrypcja i rozliczenia w jednym miejscu",
      desc: "Zarządzaj subskrypcją, metodami wypłat i historią prowizji z poziomu zakładki Profil. Wszystko przejrzyste i dostępne od razu po zalogowaniu.",
    },
    benefit6: {
      title: "Zrzutki — pełniejsza trasa",
      desc: "Klienci łączą dostawy paliwa w jedną zrzutkę. Dostajesz kilka punktów na wspólnej trasie i wyceniasz je razem zamiast jeździć po pojedynczych zamówieniach.",
    },
    promo: {
      kicker: "Promocja dla serwisantów",
      title: "Pierwsze zlecenie serwisowe za darmo",
      desc: "Nie masz zlecenia — nie płacisz. Widzisz zgłoszenia i wyceniasz bez abonamentu. Od drugiego ukończonego zlecenia (pompy, kotły, CO, AC, PV) wraca opłata za kategorię. Dostawy paliwa bez zmian.",
    },
    pricing: {
      kicker: "Cennik dla dostawców",
      title: "Przykładowe stawki platformy",
      disclaimer:
        "To przykładowy cennik. Stawki mogą być ustalane indywidualnie po kontakcie.",
      commissionsTitle: "Prowizje od dostaw paliw",
      subsTitle: "Abonamenty serwisowe (30 dni)",
      loading: "Ładowanie cennika…",
      error: "Nie udało się wczytać cennika.",
      cta: "Zapytaj o indywidualną ofertę",
      cat: {
        heat_pumps: "Serwis pomp ciepła",
        boilers: "Serwis kotłów i pieców",
        installations: "Serwis instalacji grzewczych",
        ac: "Klimatyzacja (serwis i montaż)",
        pv: "Fotowoltaika i magazyny energii",
      },
    },
    mobileApp: "Aplikacja mobilna",
    apiBadge: "Dla systemów ERP / TMS / WMS",
    apiTitle: "Łatwa integracja API & Webhooks",
    apiDesc: "Masz własny system ERP, TMS lub magazynowy (np. Subiekt, Optima, SAP)? Odbieraj zapytania, składaj oferty i przesyłaj cyfrowe podpisy odbioru w 100% automatycznie przez nasze bezpieczne REST API i webhooki.",
    apiTag1: "Automatyczne zlecenia",
    apiTag2: "Webhooki w czasie rzeczywistym",
    apiTag3: "Klucze API & HMAC",
    apiCta: "Otwórz Portal Integratora (API Docs)",
    docsTitle: "Materiały informacyjne dla partnerów",
    docsDesc: "Pobierz szczegółowy informator w formacie PDF o modelu współpracy, rozliczeniach i funkcjach platformy:",
    pdfServiceTitle: "Dla Serwisantów i Instalatorów",
    pdfServiceText: "Zalety dla Serwisantów i Instalatorów HVAC (PDF)",
    pdfFuelText: "Zalety dla Dostawców Paliw i Składów Opału (PDF)",
    gatewayFuelTitle: "Składy Opału & Dystrybutorzy Gazu",
    gatewayFuelDesc: "0 zł prowizji od własnych zleceń (0%), trasy mieszane, 1 Kod QR dla kierowcy, e-WZ, Tarcza Akcyzowa i plany flotowe.",
    gatewayTechTitle: "Instalatorzy & Serwisanci HVAC",
    gatewayTechDesc: "Pompy ciepła (F-Gaz), kotły CO, klimatyzacja, darmowy trial (1. zlecenie gratis).",
    desktopTitle: "Aplikacja desktopowa",
    desktopNote: "Pełne zarządzanie kontem, specjalizacjami i subskrypcją zostawiamy w aplikacji mobilnej — dzięki temu poufne ustawienia i uprawnienia pozostają pod kontrolą na telefonie. Desktop zawiera minimum potrzebne do wygodnej pracy przy biurku: powiadomienia o zleceniach i szybkie wyceny.",
    formTitle: "Zacznij sprzedawać z nami",
    formSubtitle: "Wypełnij krótki formularz, skontaktujemy się z Tobą",
    fieldName: "Imię i nazwisko / Nazwa firmy",
    fieldEmailPlaceholder: "twoj@email.pl",
    fieldPhone: "Numer telefonu",
    fieldPhonePlaceholder: "600 700 800",
    fieldCity: "Miejscowość i obszar działania",
    fieldCityPlaceholder: "np. Kraków i okolice do 30km",
    fieldServices: "Oferowane usługi / produkty",
    servicePropan: "Propan",
    servicePellet: "Pellet / Groszek",
    serviceBoiler: "Serwis kotłów / pomp",
    serviceAc: "Klimatyzacja",
    servicePv: "Fotowoltaika",
    fieldNotes: "Dodatkowe informacje (opcjonalnie)",
    fieldNotesPlaceholder: "Napisz kilka słów o swojej firmie...",
    consent: "Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z",
    consentPrivacy: "Polityką prywatności",
    consentPurpose: "w celu obsługi zgłoszenia i kontaktu handlowego.",
    captchaLabel: "Weryfikacja antyspamowa",
    captchaLoading: "Ładowanie pytania...",
    captchaRefresh: "Odśwież pytanie",
    captchaPlaceholder: "Wpisz wynik",
    submit: "Wyślij zgłoszenie",
    sending: "Wysyłanie...",
    instructWin: "<strong>Instrukcja (Windows):</strong> Pobierz i uruchom instalator <code>.exe</code>. Program automatycznie zainstaluje się i doda skrót na pulpicie.",
    instructMac: "<strong>Instrukcja (macOS):</strong> Pobierz plik <code>.dmg</code> (wybierz Apple Silicon dla nowych Maców z procesorami M1/M2/M3/M4 lub Intel dla starszych modeli). Otwórz go i przeciągnij aplikację do folderu Aplikacje.",
    instructLinux: "<strong>Instrukcja (Linux):</strong> Zalecamy pakiet <code>.deb</code> (ikona i menu systemowe). Jeśli korzystasz z wersji <code>AppImage</code>, po pobraniu oznacz plik jako wykonywalny (<code>chmod +x</code>) i w menedżerze plików wybierz &bdquo;Zezwól na uruchamianie&rdquo;.",
    loadingVersions: "Ładowanie wersji…",
    refreshVersions: "Odśwież listę wersji",
    errorNoAssets: "Brak plików instalacyjnych w najnowszym wydaniu.",
    errorLoad: "Nie udało się pobrać listy wersji. Spróbuj ponownie później.",
    currentVersion: "Aktualna wersja:",
    draft: "(wersja robocza)",
    seeDownloads: "Zobacz sekcję pobierania",
    warningWin: "Aplikacja jest obecnie w trakcie weryfikacji w Microsoft Store. Jeśli system Windows wyświetli ostrzeżenie przed uruchomieniem, kliknij <em>\"Więcej informacji\"</em>, a następnie <em>\"Uruchom mimo to\"</em>. Zapewniamy, że program jest w pełni bezpieczny.",
  },
  b2bFuel: {
    trustBar: "0 zł prowizji od własnych zleceń (0%) · Abonamenty flotowe · Manifest 1 Kod QR · Elektroniczna e-WZ z podpisem i akcyzą.",
    badge: "Ekosystem Logistyczny dla Składów i Dystrybutorów Paliw",
    headline: "Więcej zleceń na trasie i zero papierowych WZ-ek.",
    lead: "Łącz zamówienia własnych klientów ze zleceniami z sieci UgrzejMnie na jednej ciężarówce. Daj kierowcy 1 kod QR na cały dzień i wystawiaj cyfrowe e-WZ z oświadczeniem akcyzowym i podpisem klienta.",
    btnRegister: "Zarejestruj swój skład",
    btnPricing: "Cennik (0% prowizji)",
    btnPdf: "Pobierz informator PDF (2 str. A4)",
    featuresHeadline: "Jak ekosystem UgrzejMnie optymalizuje Twój skład?",
    featuresLead: "Zaprojektowane z myślą o realiach polskich składów opału, kierowców i kontroli skarbowych.",
    cardMixedRouteTitle: "Trasa Mieszana A+B",
    cardMixedRouteDesc: "Obsługujesz stałych klientów z placu? Wprowadź ich zlecenia (Stream B) z 0 zł prowizji (0%) i dobieraj zamówienia z sieci UgrzejMnie (Stream A) po drodze. Płacisz prowizję tylko za pozyskane nowe zlecenia.",
    cardMixedRouteBadge: "Wspólna waga & TSP",
    cardQrTitle: "Kurs Dnia i Manifest QR",
    cardQrDesc: "Kierowca rano skanuje 1 kod QR z kabiny. Ma gotową, automatycznie zoptymalizowaną kolejność przystanków od Twojego placu oraz przyciski natychmiastowej nawigacji Google Maps.",
    cardQrBadge: "Zero instalowania aplikacji",
    cardEwzTitle: "Elektroniczna e-WZ & Akcyza",
    cardEwzDesc: "Wymóg PESEL / serii i numeru dowodu, oświadczenie o przeznaczeniu opału pod zwolnienie z akcyzy, cyfrowy podpis klienta palcem na ekranie, stempel GPS i zbiorczy eksport do CSV dla Urzędu Skarbowego.",
    cardEwzBadge: "Tarcza Akcyzowa",
    cardOfflineTitle: "100% Offline & Zrzut z trasy",
    cardOfflineDesc: "Brak zasięgu LTE na posesji klienta? Cały manifest, odbiór i podpisy działają offline. Kierowca może też na miejscu wbić klienta „z drogi” („panie, zrzuć mi tonę”), a dane zsynchronizują się automatycznie.",
    cardOfflineBadge: "Outbox Sync",
    cardAdjustTitle: "Auto-Rozliczenie Litrażu",
    cardAdjustDesc: "Dla dostaw cysterną: jeśli do zbiornika weszło mniej niż w zamówieniu, system natychmiast zwraca klientowi różnicę na kartę (Stripe Connect). Nadwyżkę kierowca rozlicza gotówką na miejscu wg stałej stawki z oferty.",
    cardAdjustBadge: "Zero sporów",
    cardApiTitle: "Otwarte API Integratora",
    cardApiDesc: "Połącz UgrzejMnie bezpośrednio z systemem ERP/TMS swojego składu (Subiekt, Symfonia, Comarch). Zlecenia i oferty spływają przez bezpieczne Webhooki machine-to-machine.",
    cardApiBadge: "REST + Webhooki",
    puescBadge: "Dostępne — Integracja z PUESC",
    puescHeadline: "SENT i e-DD prosto z trasy — automatycznie do MF",
    puescLead: "Moduł PUESC działa w aplikacji dostawcy i pulpicie. Deklaracje SENT (transportowe) i e-DD (dostawy pod akcyzę) powstają z realizacji trasy i są podpisywane kwalifikowanym podpisem — bez ręcznego przepisywania danych do e-Urząd Skarbowy.",
    puescSoon: "Dostępne",
    puescSentTitle: "SENT — Deklaracje Transportowe",
    puescSentDesc: "Automatyczne zgłoszenia transportu wyrobów akcyzowych do Systemu Elektronicznego Nadzoru Transportu. Dane trasy, pojazdu i kierowcy pobierane są wprost z Kursu Dnia — zero dublowania wpisów w e-Urzędzie Skarbowym.",
    puescEddTitle: "e-DD — Elektroniczne Dokumenty Dostawy",
    puescEddDesc: "Elektroniczne dokumenty dostawy dla opału pod akcyzą, podpisywane kwalifikowanym certyfikatem XAdES. Generowane automatycznie z e-WZ po potwierdzeniu odbioru przez klienta — z numerem PESEL, stopelem GPS i oświadczeniem akcyzowym.",
    puescCtaTitle: "Włącz SENT i e-DD w swoim składzie",
    puescCtaDesc: "Moduł PUESC jest w planach Pro i Enterprise. Wybierz pakiet flotowy albo napisz — wdrożymy go na Twoich trasach.",
    puescCtaBtn: "Zobacz pakiety flotowe",
    lpgSentBadge: "SENT dla stacji LPG / autogaz",
    lpgSentHeadline: "Jedna trasa — trzy ścieżki zamknięcia SENT ze stacją",
    lpgSentLead: "Dostawy LPG autogaz na stacje paliw wymagają SENT-100 i SENT-103 z odczytami dystrybutorów. UgrzejMnie rozróżnia stację własną (ten sam NIP) i obcą (inna firma) oraz obsługuje klucz RecipientKey (KR-…) — bez logowania stacji do konta PUESC dostawcy.",
    lpgPathOwnKicker: "1 · Własny NIP",
    lpgPathOwnTitle: "Stacja własna / ta sama firma",
    lpgPathOwnDesc: "Po rozładunku kierowca zapisuje odczyty dystrybutorów. System zamyka SENT-103 w PUESC w imieniu dostawcy (STANDARD) — bez klucza KR.",
    lpgPathKrKicker: "2 · Obcy NIP + KR",
    lpgPathKrTitle: "Franchise / stacja partnerska z RecipientKey",
    lpgPathKrDesc: "Stacja raz podaje klucz KR-… (portal e-mail lub kartoteka). Po dostawie zamykacie SENT-103 w jej imieniu: oficjalny numer SENT + RecipientKey + odczyty.",
    lpgPathExtKicker: "3 · Obcy NIP bez KR",
    lpgPathExtTitle: "Stacja zamyka u siebie w PUESC",
    lpgPathExtDesc: "Mail z referencją, potem oficjalny numer SENT i odczyty dystrybutorów. Stacja zamyka SENT-103 na swoim koncie; operator potwierdza w pulpicie (CONFIRMED_EXTERNALLY).",
    lpgSentBullet1: "Dwa maile do stacji: po rejestracji (referencja) i po nadaniu oficjalnego numeru SENT przez PUESC.",
    lpgSentBullet2: "Portal stacji (magic link) do jednorazowego podania klucza RecipientKey — bez konta w Waszej aplikacji.",
    lpgSentBullet3: "Odczyty liczników dystrybutorów z trasy; możliwa korekta przed potwierdzeniem zewnętrznym.",
    lpgSentDocBtn: "Informator SENT stacje LPG (HTML / druk PDF)",
    lpgSentContactBtn: "Porozmawiaj o wdrożeniu na stacjach",
    lpgSentLegal: "Jak w całym module PUESC: odpowiedzialność za zgłoszenia i uprawnienia w SISC pozostaje po stronie dostawcy. Narzędzie nie zastępuje konta PUESC stacji ani decyzji podatkowej.",
    pricingKicker: "Cennik dla Dostawców Paliw",
    pricingHeadline: "Prowizja tylko od nowych zleceń + Abonament dla floty",
    pricingLead: "0% prowizji od własnych stałych klientów (Stream B). Płacisz prowizję sukcesu wyłącznie wtedy, gdy przynosimy Ci nowego klienta z rynku.",
    streamATitle: "Zlecenia z Platformy (Stream A)",
    streamADesc: "Dla zamówień pozyskiwanych z aplikacji UgrzejMnie od właścicieli domów, gospodarstw i firm w Twoim regionie.",
    streamARate: "0,5% – 1,0%",
    streamANote: "Prowizja sukcesu naliczana wyłącznie od zrealizowanych zleceń",
    streamBTitle: "Zlecenia Własne Składu (Stream B)",
    streamBDesc: "Dla Twoich stałych klientów z placu, telefonu lub pliku Excel. Zero prowizji od wartości sprzedaży.",
    streamBRate: "0 zł (0% prowizji)",
    streamBNote: "0 zł prowizji od sprzedaży Twojego opału i Twoich własnych klientów",
    monthlyInvoiceTitle: "Jedna zbiorcza faktura B2B raz w miesiącu",
    monthlyInvoiceDesc: "Prowizje od pozyskanych zleceń z rynku (Stream A) oraz ewentualny abonament flotowy (Plan Pro / Enterprise w trybie faktury B2B) rozliczane są na koniec miesiąca z 14-dniowym terminem płatności. Zlecenia własne składu (Stream B) objęte są stawką 0 zł (0%).",
    zeroHiddenFees: "0 zł ukrytych opłat",
    puescLoading: "Ładowanie cennika pakietów…",
    puescError: "Cennik pakietów niedostępny — skontaktuj się z nami.",
    puescKicker: "Abonamenty Flotowe i Narzędzia Składu",
    puescPlansHeadline: "Wybierz pakiet dopasowany do wielkości Twojej floty",
    puescPlansLead: "Plan Basic bez opłat stałych (płacisz tylko prowizję za nowych klientów ze Stream A) lub plany abonamentowe Pro / Enterprise z modułem PUESC (SENT i e-DD). Ceny abonamentów objęte są stawką promocyjną do końca 2026 r.",
    puescNote: "Ceny abonamentów netto. Promocja do końca 2026 r. Plan Basic bez stałych opłat — zawsze 0 zł miesięcznie i 0 zł prowizji od Twoich własnych klientów (Stream B).",
    pdfTitle: "Pobierz Informator dla Dostawców (PDF)",
    pdfDesc: "Kompletne kompendium w formacie 2 stron A4: automatyzacja PUESC / SENT / e-DD, zarządzanie flotą z e-TOLL, trasy mieszane A+B (0% prowizji), schemat Kursu Dnia QR oraz cyfrowa e-WZ i akcyza pod kontrole Urzędu Skarbowego.",
    formHeadline: "Potrzebujesz indywidualnego wdrożenia floty?",
    formLead: "Możesz zacząć od razu, pobierając aplikację mobilną powyżej. Jeśli prowadzisz duży skład, flotę aut lub potrzebujesz pomocy we wpięciu pierwszych tras — zostaw kontakt, nasz zespół oddzwoni.",
    formSubmit: "Wyślij zapytanie wdrożeniowe",
  },
  b2bTech: {
    trustBar: "Darmowy Trial — 1. zlecenie w 100% gratis · Cyfrowy protokół serwisowy · Zlecenia z Twojego powiatu.",
    badge: "Strefa B2B dla Instalatorów & Serwisantów HVAC",
    headline: "Więcej zleceń w Twoim powiecie i pewne rozliczenia.",
    lead: "Odbieraj bezpośrednie zapytania od właścicieli domów o przeglądy pomp ciepła (F-Gaz), serwis kotłów CO, montaż klimatyzacji i fotowoltaiki. Wypróbuj bez ryzyka — pierwsze zrealizowane zlecenie w 100% bez prowizji i bez abonamentu!",
    btnJoin: "Pobierz aplikację i dołącz",
    btnPricing: "Cennik i Trial",
    btnPdf: "Pobierz PDF",
    featuresHeadline: "Jakie zlecenia czekają w UgrzejMnie?",
    featuresLead: "Łączymy Cię z klientami potrzebującymi serwisu dokładnie w promieniu Twojego działania.",
    pricingKicker: "Cennik dla Serwisantów",
    pricingHeadline: "Darmowy Trial i elastyczne abonamenty powiatowe",
    pricingLead: "Przejrzyste zasady bez ukrytych prowizji. Płacisz tylko wtedy, gdy chcesz odbierać zlecenia z danego regionu.",
    trialTitle: "Pakiet Powitalny (Free First Job)",
    trialDesc: "Dla każdego nowego instalatora i serwisanta rejestrującego konto w aplikacji.",
    trialRate: "0 zł",
    trialNote: "Pierwsze wykonane zlecenie w 100% bez prowizji i bez abonamentu",
    subsTitle: "Abonament Serwisowy (30 dni)",
    subsDesc: "Aktywowany po zrealizowaniu darmowego zlecenia próbnego dla wybranej kategorii.",
    subsRate: "39 – 49 zł / 30 dni",
    subsNote: "0% prowizji od zrealizowanych usług przy aktywnym abonamencie",
    pdfTitle: "Pobierz Informator dla Serwisantów (PDF)",
    pdfDesc: "Poznaj szczegóły współpracy: zasady przydziału zapytań w powiatach, wzór cyfrowego protokołu odbioru oraz kalkulację korzyści dla firm instalatorskich.",
    formHeadline: "Potrzebujesz pomocy we wdrożeniu firmy?",
    formLead: "Możesz zarejestrować się samodzielnie w aplikacji mobilnej. Jeśli masz pytania lub reprezentujesz większą firmę instalacyjną — zostaw kontakt, pomożemy skonfigurować Twój profil.",
    formSubmit: "Wyślij zapytanie kontaktowe",
  },
  faq: {
    heading: "Najczęstsze pytania",
    sub: "Krótko o tym, jak działa UgrzejMnie — zanim pobierzesz aplikację.",
    q1: "Czym jest UgrzejMnie?",
    a1: "To aplikacja łącząca Cię z lokalnymi dostawcami paliwa oraz serwisantami ogrzewania, klimatyzacji i fotowoltaiki. Składasz zlecenie, dostajesz oferty i wybierasz tę, która Ci odpowiada.",
    q2: "Jakie usługi obsługujecie?",
    a2: "W aplikacji zamówisz paliwo i serwis dla kotłowni na paliwo stałe (pellet, groszek), zbiorników LPG i propanu, kotłowni gazowych, pomp ciepła oraz ogrzewania elektrycznego, a także serwis i montaż klimatyzacji oraz instalacji fotowoltaicznych.",
    q3: "Czy aplikacja przypomni mi o zbliżającym się serwisie?",
    a3: "Tak. Możesz zapisać swoją instalację grzewczą wraz z datą kolejnego przeglądu. UgrzejMnie wyśle Ci powiadomienie z wyprzedzeniem, abyś zdążył zamówić serwis u wybranego fachowca.",
    q4: "Kto dostarcza paliwo i robi serwis?",
    a4: "Niezależni dostawcy i serwisanci z Twojej okolicy. UgrzejMnie jest marketplace — kojarzymy strony, ale umowę i realizację ustalasz bezpośrednio z wybranym fachowcem.",
    q5: "Jakie metody płatności są dostępne na ugrzejmnie.pl?",
    a5: "Dostępne metody zależą od oferty dostawcy. Możesz wybrać <strong>płatność u kierowcy (gotówka / COD)</strong> według ceny bazowej oferty (0 zł opłaty platformy) albo <strong>płatność zabezpieczoną online</strong> (karta, BLIK, P24 lub Klarna) z Pakietem Bezpiecznej Płatności i wsparciem reklamacyjnym platformy — opłata serwisowa jest prezentowana wprost przed zatwierdzeniem płatności.",
    q6: "Jak sprawdzić, jakie płatności oferuje dany dostawca?",
    a6: "Formy płatności akceptowane przez sprzedawcę są zawsze wyraźnie widoczne na karcie konkretnej oferty przy składaniu zamówienia lub zapytania o wycenę.",
    q7: "Jak działa płatność odroczona Klarna za opał?",
    a7: "Jeśli wybrany przez Ciebie dostawca obsługuje płatności Klarna, możesz zamówić opał z opcją &bdquo;Kup teraz, zapłać później&rdquo; (warunki Klarna są prezentowane w Checkout). Zyskujesz możliwość odbioru dostawy zgodnie z umową z dostawcą, a rozliczenie z Klarną odbywa się według jej regulaminu.",
    q8: "Czy płatności online na ugrzejmnie.pl są bezpieczne?",
    a8: "Tak. Płatności cyfrowe realizowane są przez certyfikowane bramki płatnicze operatora Stripe, posiadające najwyższy międzynarodowy standard bezpieczeństwa PCI-DSS Level 1. Żadne dane Twojej karty nie są przechowywane w serwisie ugrzejmnie.pl.",
    q9: "Czy jest aplikacja na iPhone?",
    a9: "Aplikacja dla klientów i dostawców jest obecnie dostępna na Androida. Wersja na iOS jest w przygotowaniu i pojawi się wkrótce.",
    q10: "Czy działa w mojej okolicy?",
    a10: "Oferty pochodzą od lokalnych dostawców. Im więcej serwisantów w regionie, tym szybciej dostaniesz odpowiedzi. Pobierz aplikację i sprawdź dostępność u siebie.",
    q11: "Dlaczego przy dostawie paliwa może być potrzebny PESEL?",
    a11: "Przy dostawach paliw (płynne, stałe, LPG, butle) Platforma może wymagać PESEL do dokumentacji dostawcy. Numer trafia wyłącznie do przypisanego dostawcy i nie służy do marketingu — szczegóły są w Polityce prywatności.",
    q12: "Jestem serwisantem — jak zacząć?",
    a12: "Pobierz aplikację mobilną dostawcy, uzupełnij profil i specjalizacje. Serwisanci zaczynają bez abonamentu: pierwsze ukończone zlecenie (pompy, kotły, CO, AC, PV) jest darmowe — od drugiego wraca opłata za kategorię. Możesz też zapraszać stałych klientów linkiem lub kodem QR. Do pracy przy komputerze możesz dołożyć aplikację desktopową (Windows, macOS, Linux) — szczegóły w sekcji Dla dostawców.",
    q13: "Do czego służy aplikacja desktopowa dostawcy?",
    a13: "Desktop to wygodny dodatek przy biurku: powiadomienia o nowych zleceniach i szybkie wyceny. Pełne zarządzanie kontem, specjalizacjami i subskrypcją zostaje w aplikacji mobilnej — dzięki temu poufne ustawienia pozostają pod kontrolą na telefonie, a na komputerze jest tylko niezbędne minimum.",
    q14: "Dlaczego zamawianie odbywa się w aplikacji, a nie przez formularz WWW?",
    a14: "Aplikacja mobilna to tarcza bezpieczeństwa całego marketplace'u. Chroni dostawców i klientów przed fałszywymi zamówieniami, umożliwia natychmiastowe powiadomienia push (o wycenie, terminie i akceptacji dostawy) oraz buduje historię zaufania zweryfikowanego konta — czego nie gwarantuje anonimowy formularz WWW.",
    q15: "Czym jest zrzutka paliwa?",
    a15: "To wspólna dostawa z sąsiadami. Otwierasz zrzutkę w aplikacji, wysyłasz link lub kod, a sąsiedzi dołączają własną ilością tego samego paliwa i opakowania. Dostawca jedzie jedną trasą — często wychodzi taniej niż osobne dojazdy.",
  },
  footer: {
    tagline: "Paliwo i serwis kotłowni — gdy trzeba.",
    facebook: "Śledź nas na Facebooku",
    toTop: "Do góry",
    contact: "Kontakt",
    navigation: "Nawigacja",
    navAria: "Szybkie linki",
    legal: "Informacje",
    legalAria: "Informacje prawne",
    privacy: "Polityka prywatności",
    terms: "Regulamin",
    apiDocs: "Portal Integratora (API)",
    pdfService: "Zalety dla Serwisantów (PDF)",
    pdfFuel: "Zalety dla Dostawców (PDF)",
    pdfLpgSent: "SENT stacje LPG (informator)",
    forProviders: "Dla Składów Opału",
    forTechnicians: "Dla Serwisantów",
    copyright: "© 2026 UgrzejMnie · HelpMeNow Prosta S.A. Wszelkie prawa zastrzeżone.",
    companyName: "HelpMeNow Prosta S.A.",
    address: "ul. Wspólna 2, 96-330 Mrozy",
    registry: "KRS 0001127133 · NIP 8381887256 · REGON 529645405",
    phone: "+48 690 355 556",
  },
  cookie: {
    text: "Nasza strona korzysta z plików cookies niezbędnych do jej prawidłowego działania, w tym zapamiętywania preferencji (np. kodu zaproszenia od dostawcy). Więcej informacji znajdziesz w naszej",
    privacyLink: "Polityce prywatności",
    accept: "Rozumiem",
  },
  // SENTBeton — dla-betonu.html (samodzielna strona, klucze z prefiksem sb.)
  sb: {
    meta: {
      title: "SENTBeton — gotowość węzła pod SENT dla betonu",
      description: "Program early adopterów dla betoniarni: gotowe e-WZ zgodne z PN-EN 206 (pobierz wzór PDF), przygotowanie pod SENT (projekt UD437), link realizacji i API. Bez panelu WWW — zanim przepisy wejdą w życie.",
      ogTitle: "SENTBeton — gotowość / early adopters",
      ogDescription: "Budujemy listę węzłów, które chcą być gotowe na SENT dla betonu towarowego. e-WZ, gruszki, API — już teraz, bez czekania na Dziennik Ustaw.",
    },
    nav: {
      aria: "Nawigacja",
      ewz: "e-WZ",
      how: "Jak działa",
      products: "Produkty",
      faq: "FAQ",
      early: "Early adopters",
      blog: "Blog & Wiedza",
      contact: "Kontakt",
    },
    hero: {
      kicker: "Program gotowości · early adopters · projekt UD437",
      ready: "<strong>Gotowość</strong> Beton towarowy nie jest jeszcze objęty SENT w obowiązującym prawie. Budujemy listę węzłów, które chcą mieć e-WZ, procesy i integracje gotowe — zanim przepisy (projekt UD437) wejdą w życie.",
      h1: "Przygotuj węzeł, zanim SENT na beton zacznie obowiązywać",
      lead: "SENTBeton to narzędzia dla wytwórni i flot gruszek: pulpit dyspozytora, aplikacja kierowcy, link realizacji oraz API. Bez panelu WWW do codziennej pracy. Dołączasz jako early adopter — wdrażamy procesy i dokumenty już teraz, dostosujemy komunikację SENT gdy tekst ustawy się ustabilizuje.",
      ctaJoin: "Dołącz do early adopterów",
      ctaEwz: "Pobierz przykładową e-WZ (PDF)",
      ctaFlow: "Zobacz przebieg kursu",
      ctaNote: "e-WZ zgodne z PN-EN 206, pulpit dyspozytora i aplikacja kierowcy — już dostępne, przetestuj dziś. Link realizacji i API — do ustalenia przy wdrożeniu. Bez obietnicy daty obowiązku prawnego.",
    },
    ewz: {
      h2: "e-WZ jest gotowe — pełny dokument wg PN-EN 206",
      lead: "Nasza cyfrowa e-WZ zastępuje papierową kartę dostawy z węzła betoniarskiego. Dokument generowany jest przed wyjazdem gruszki, zawiera komplet parametrów receptury i jest gotowy do okazania w trasie — także przed podpisem odbiorcy.",
      i1: "<strong>Receptura:</strong> klasa i klasy ekspozycji, konsystencja, maksymalne uziarnienie D<sub>max</sub>, rodzaj i klasa cementu, domieszki chemiczne, wskaźnik w/c",
      i2: "<strong>Certyfikacja:</strong> numer Krajowego Certyfikatu ZKP, Znak Budowlany B, odniesienie do PN-EN 206+A2:2021-08 i PN-B-06265",
      i3: "<strong>Czasy technologiczne:</strong> godzina zarobu na węźle oraz rejestracja przyjazdu i rozładunku — dowód dotrzymania okna 90–120 min",
      i4: "<strong>Kontrola drogowa:</strong> dokument do okazania ITD/KAS lub kierownikowi budowy jeszcze przed zrzutem — z numerem SENT i kodem QR, gdy zgłoszenie już obowiązuje",
      i5: "<strong>Dolanie wody:</strong> klauzula prawna z adnotacją o ilości i osobie zlecającej oraz podpisem odpowiedzialnym",
      i6: "<strong>Awaria PUESC:</strong> gdy rejestr nie odpowiada — przewóz na dokumencie WZ i ponowienie zgłoszenia po powrocie bramki",
      dlTag: "Dokumenty dostępne",
      dlText: "Tak wyglądają dokumenty generowane przez SENTBeton: e-WZ z recepturą i czasami przed wyjazdem oraz POD po podpisie odbiorcy — tu z zapisanym dolaniem wody i klauzulą prawną.",
      btnEwz: "Otwórz wzór e-WZ (PDF)",
      btnPod: "Otwórz wzór POD (PDF)",
      btnCsv: "Pobierz wzór CSV (import masowy)",
      dlNote: "Dokumenty poglądowe — dane przykładowe. W CSV tylko kolumny oznaczone <strong>*</strong> są wymagane (klient, telefon, adres budowy); pozostałe — w tym <code>lat</code>/<code>lng</code> i czasy technologiczne — są opcjonalne.",
    },
    flow: {
      h2: "Jak wygląda jeden kurs",
      lead: "Typowy dzień na węźle: dyspozytor planuje wydania, gruszka jedzie na budowę, odbiorca potwierdza dostawę, system domyka dokumenty i komunikację z PUESC.",
      s1t: "Plan i wydanie WZ",
      s1d: "Na pulpicie dyspozytora: receptura / klasa betonu, kubatura, nr WZ, pojazd, kierowca, adres budowy i okno czasowe.",
      s2t: "Start kursu",
      s2d: "Kierowca dostaje zlecenie w aplikacji albo jednorazowy link (SMS / WhatsApp / e-mail z domeny sentbeton.pl). Bez zakładania konta w przeglądarce.",
      s3t: "Zgłoszenie SENT",
      s3d: "Przy wyjeździe system przygotowuje i wysyła zgłoszenie przewozu (m.in. SENT-100) powiązane z WZ. Dla betonomieszarek — bez wymogu lokalizatora OBU/ZSL.",
      s4t: "Na budowie: e-WZ",
      s4d: "Odbiorca podpisuje potwierdzenie na telefonie. Zostaje cyfrowy protokół (POD / e-WZ) z czasem i danymi kursu.",
      s5t: "Zamknięcie i awarie",
      s5d: "Po dostawie domknięcie SENT. Gdy bramka PUESC nie odpowiada — tryb awarii oparty o WZ i ponowienie po powrocie łączności (odpowiedzialność merytoryczna po stronie wytwórni).",
    },
    products: {
      h2: "Co wchodzi w SENTBeton",
      lead: "Jedna platforma, kilka punktów styku — tak, żeby dyspozycja, kierowca i ERP węzła nie musiały żyć w przeglądarce.",
      avail: "Dostępne",
      p1t: "Pulpit dyspozytora",
      p1d: "Aplikacja desktopowa SENTBeton Dyspozytor (Windows, macOS, Linux).",
      p1i1: "wystawianie e-WZ i planowanie kursów",
      p1i2: "statusy SENT i historia zgłoszeń",
      p1i3: "kontrola drogowa / tryb awarii",
      p1i4: "ustawienia PUESC i floty gruszek",
      p2t: "Aplikacja kierowcy",
      p2d: "SENTBeton Kierowca na Androidzie (iOS w kolejce).",
      p2i1: "lista kursów i nawigacja do budowy",
      p2i2: "podpis odbiorcy na miejscu",
      p2i3: "praca offline z późniejszą synchronizacją",
      p2i4: "ekran kontroli drogowej / WZ awaryjne",
      p3t: "Link realizacji",
      p3d: "Jednorazowy adres z SMS, WhatsApp lub e-maila — bez instalacji.",
      p3i1: "szczegóły WZ i adres budowy",
      p3i2: "potwierdzenie dojazdu",
      p3i3: "cyfrowy podpis na budowie",
      p3i4: "linki z domeny sentbeton.pl",
      p4tag: "Dla IT węzła",
      p4t: "API integratora",
      p4d: "Open API do podpięcia ERP / systemu dyspozycji betoniarni.",
      p4i1: "tworzenie zleceń / wydań z zewnątrz",
      p4i2: "webhooki statusów i dokumentów",
      p4i3: "załączniki WZ, podpisy, metadane SENT",
      p4i4: "ten sam backend co pulpit i aplikacja",
    },
    apiBox: {
      h3: "Integracja bez „panelu WWW”",
      p: "Codzienna praca idzie przez pulpit, aplikację kierowcy, linki i API. Strona sentbeton.pl służy do informacji i kontaktu — nie do logowania dyspozytora. Dokumentację API i dostęp testowy ustalamy przy wdrożeniu (<a href=\"mailto:kontakt@sentbeton.pl?subject=SENTBeton%20API\">kontakt@sentbeton.pl</a>).",
    },
    sent: {
      h2: "SENT dla betonu — przygotowanie pod projekt UD437",
      lead: "Po wecie wcześniejszej nowelizacji rząd wrócił do tematu projektem UD437 (m.in. beton w gruszkach, bez lokalizatora OBU/ZSL w założeniach). To nadal projekt — nie obowiązujące prawo. Poniżej obszary, które adresujemy w produkcie, żeby węzeł mógł wejść w obowiązek spokojnie, a nie „z dnia na dzień”.",
      th1: "Temat",
      th2: "Kontekst (projekt)",
      th3: "W narzędziach SENTBeton",
      r1c1: "Zgłoszenie",
      r1c2: "Kursy betonu towarowego betonomieszarkami",
      r1c3: "Przygotowanie procesów i wysyłki powiązanej z WZ",
      r2c1: "GPS / OBU",
      r2c2: "Zakładane wyłączenie dla gruszek",
      r2c3: "Konfiguracja bez wymogu lokalizatora",
      r3c1: "Miara",
      r3c2: "Kubatura (m³), masa wg gęstości",
      r3c3: "m³ w e-WZ i w danych zgłoszenia",
      r4c1: "Awaria PUESC",
      r4c2: "Procedura awaryjna / dokument WZ",
      r4c3: "Tryb awarii + ponowienie po powrocie bramki",
      r5c1: "Odbiorca B2C",
      r5c2: "Klient prywatny w założeniach projektu",
      r5c3: "Potwierdzenie po stronie nadawcy / węzła",
      note: "SENTBeton udostępnia oprogramowanie pośredniczące. Za rzetelność danych i skutki skarbowe odpowiada wytwórnia — szczegóły w <a href=\"/regulamin\">Regulaminie</a>. Treść UD437 może się zmienić w toku legislacji; produkt aktualizujemy pod finalny tekst.",
    },
    faq: {
      h2: "Najczęstsze pytania",
      lead: "Odpowiedzi dla dyspozytorów, kierowników węzła i osób od dokumentacji.",
      q1: "Czy e-WZ jest już dostępne, czy to „coming soon”?",
      a1: "Jest dostępne. Dokument e-WZ generujemy już dziś — przed wyjazdem gruszki, jako PDF strony A4 z pełną recepturą, czasami technologicznymi i numerem SENT. Możesz <a href=\"/static/landing/assets/sentbeton/przykladowa-e-wz.pdf\" target=\"_blank\" rel=\"noopener\">pobrać wzór e-WZ</a> oraz <a href=\"/static/landing/assets/sentbeton/przykladowy-pod.pdf\" target=\"_blank\" rel=\"noopener\">wzór POD po podpisie</a> i porównać je z papierową kartą dostawy z węzła.",
      q2: "Jak wprowadzić dziesiątki zleceń naraz? Czy jest import CSV?",
      a2: "Tak — dyspozytor importuje masowe zlecenia z pliku CSV (separator średnik, kodowanie UTF-8). Wymagane są tylko trzy kolumny oznaczone gwiazdką: <code>klient*</code>, <code>telefon*</code> i <code>adres_budowy*</code>. Pozostałe — receptura PN-EN 206 (D<sub>max</sub>, cement, domieszki, w/c, ZKP), czasy technologiczne, współrzędne GPS (<code>lat</code>/<code>lng</code> — geokodujemy z adresu, gdy ich nie podasz) czy zapis dolania wody — są opcjonalne. <a href=\"/static/landing/assets/sentbeton/wzor_dostaw_betonu.csv\" target=\"_blank\" rel=\"noopener\">Pobierz wzór CSV</a> z trzema przykładowymi dostawami: pełną, standardową i minimalną.",
      q3: "Czy e-WZ spełnia wymogi normy PN-EN 206?",
      a3: "Tak — dokument projektowaliśmy pod pkt 7.3 PN-EN 206+A2:2021-08 (dowód dostawy betonu towarowego) oraz krajową PN-B-06265. Na e-WZ trafiają m.in. klasa wytrzymałości i ekspozycji, konsystencja, maksymalne uziarnienie kruszywa D<sub>max</sub>, rodzaj i klasa cementu, domieszki chemiczne, wskaźnik w/c oraz numer Krajowego Certyfikatu ZKP z odniesieniem do Znaku Budowlanego B.",
      q4: "Co się dzieje, gdy odbiorca każe kierowcy dolać wodę na budowie?",
      a4: "Kierowca w linku realizacji lub aplikacji przełącza opcję „dolano wodę na życzenie odbiorcy” i wpisuje ilość litrów oraz imię, nazwisko i funkcję osoby zlecającej (np. kierownika budowy). Przy podpisie odbiorca widzi jednoznaczną klauzulę: dolanie wody po zarobie bez zgody projektanta powoduje utratę gwarancji wytwórni na deklarowaną klasę wytrzymałości. Na końcowym dokumencie POD zapis jest wyraźnie wyróżniony; gdy wody nie dolano — dokument zawiera formalne oświadczenie „nie dolewano wody na budowie, mieszanka zgodna z recepturą”.",
      q5: "Jak udowodnić dotrzymanie limitu 90–120 minut od zarobu?",
      a5: "Na e-WZ drukowany jest czas zarobu / załadunku na węźle. Kierowca rejestruje następnie godzinę przyjazdu na budowę oraz rozpoczęcia i zakończenia wyładunku (system podpowiada bieżący czas). Wszystkie czasy lądują na POD, więc przy reklamacji lub ekspertyzie masz zapis dowodzący wbudowania mieszanki w oknie technologicznym.",
      q6: "Co kierowca okaże przy kontroli drogowej lub kierownikowi budowy?",
      a6: "Od razu w trasie — bez czekania na podpis odbiorcy — kierowca ma duży przycisk „Okaż e-WZ / SENT (PDF)” w linku realizacji i w aplikacji. Dziś dokument zawiera komplet danych PN-EN 206 oraz oznaczenie trybu przygotowawczego (beton nie podlega jeszcze SENT); po wejściu przepisów ten sam dokument pokaże numer referencyjny SENT i kod QR. Działa również w trybie awarii PUESC jako WZ awaryjne zgodne z procedurą projektu UD437.",
      q7: "Czy betonomieszarka potrzebuje lokalizatora OBU/ZSL albo aplikacji SENT Monitor?",
      a7: "W założeniach projektu UD437 przewozy betonu towarowego betonomieszarkami mają być zwolnione z wymogu lokalizacji pojazdu. SENTBeton jest od początku konfigurowany bez OBU/ZSL. Projekt nadal jest w legislacji — finalne brzmienie przepisów może się zmienić, a produkt zaktualizujemy pod opublikowany tekst.",
      q8: "A jeśli odbiorca to klient prywatny (B2C)?",
      a8: "Projekt UD437 zakłada, że klient prywatny nie musi potwierdzać odbioru w rejestrze SENT — potwierdzenie zbieramy po stronie nadawcy / węzła, jako cyfrowy podpis na telefonie odbiorcy lub kierowcy wraz z timestampem i współrzędnymi GPS miejsca podpisania.",
      q9: "Jak wygląda podpis i co z RODO?",
      a9: "Odbiorca podpisuje protokół palcem na ekranie telefonu — bez zakładania konta. Przed podpisem wyświetlamy klauzulę RODO; podpis wraz z datą, godziną i geolokalizacją trafia na dokument POD. Dane przetwarzamy zgodnie z <a href=\"/polityka-prywatnosci\">Polityką prywatności</a>.",
      q10: "Czy można podepnąć ERP / system węzła?",
      a10: "Tak — API integratora pozwala tworzyć zlecenia i wydania z zewnętrznego systemu, odbierać webhooki statusów i pobierać dokumenty WZ/POD. Dostęp testowy i dokumentację ustalamy przy wdrożeniu: <a href=\"mailto:kontakt@sentbeton.pl?subject=SENTBeton%20API\">kontakt@sentbeton.pl</a>.",
    },
    close: {
      h2: "Early adopters — lista węzłów",
      p: "Szukamy betoniarni, które chcą przećwiczyć e-WZ, linki dla kierowców i API zanim SENT na beton zacznie obowiązywać. Bez kampanii strachu o kary — konkretna gotowość operacyjna. Napisz, dołączymy Cię do listy.",
    },
    footer: {
      copy: "© 2026 SENTBeton · marka HelpMeNow Prosta S.A.",
      terms: "Regulamin",
      privacy: "Polityka prywatności",
    },
    cookie: {
      aria: "Informacja o cookies",
      text: "Ta strona używa niezbędnych plików cookies i lokalnej pamięci przeglądarki (m.in. zapamiętanie tej informacji). Szczegóły w <a href=\"/polityka-prywatnosci\">Polityce prywatności</a>.",
      btn: "Rozumiem",
    },
  },
};
